import React from 'react';
import { useSwipe } from '../../hooks/useSwipe';

const Slide = ({cardDetails, index, visibleIndex, moveLeft, moveRight, fireAmplitude}) => {
  const {large_card_image, cta_url, cta_text, description, newsroom_post_thumbnail} = cardDetails;

  const ctaOnClick = () => {
    window.open(cta_url);
    fireAmplitude('carousel_slide', cardDetails.cta_url)
  }

  const touchEventHandler = useSwipe({
      onSwipedLeft: () => moveRight(),
      onSwipedRight: () => moveLeft()
    });

  return (
    <li
      className={`slide ${index === visibleIndex ? 'active-slide' : ''}`}
      data-orbit-slide={index}
      {...touchEventHandler}
    >
      <img src={large_card_image ? large_card_image : newsroom_post_thumbnail}/>
      <div className="card-info">
        <div
          className="ck-editor-content"
          dangerouslySetInnerHTML={{ __html: description }}></div>
      </div>
      {cta_url &&
        <div className="cta-container">
          <button
            className="cta-button"
            onClick={ctaOnClick}
          >
            {cta_text}
          </button>
        </div>
      }
    </li>
  )
}

export default Slide;